(function () {
  'use strict';

  var VERSION = '20260506-tour-demo-v3';
  var STORAGE_ENABLE = 'florame_guided_tour_demo_enabled_v1';
  var STORAGE_MOOD = 'florame_guided_tour_mood_v1';
  var ROOT_CLASS = 'florame-tour-active';
  var shell = null;
  var launcher = null;
  var liveRegion = null;
  var currentIndex = 0;
  var selectedMood = '';
  var lang = 'it';
  var svgSerial = 0;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key) || ''; } catch (_) { return ''; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  }

  function storageRemove(key) {
    try { window.localStorage.removeItem(key); } catch (_) {}
  }

  function getParams() {
    try { return new URLSearchParams(window.location.search || ''); } catch (_) { return new URLSearchParams(''); }
  }

  function hasTourParam() {
    var params = getParams();
    return params.has('florameTourDemo') || params.has('florameTour') || params.get('tour') === 'florame';
  }

  function shouldAutoStart() {
    if (window.__florameGuidedTourDemoAutoStart === true) return true;
    var params = getParams();
    var raw = String(params.get('florameTourDemo') || params.get('florameTour') || '').toLowerCase();
    return raw === '1' || raw === 'start' || raw === 'true';
  }

  function isEnabled() {
    return hasTourParam() || storageGet(STORAGE_ENABLE) === '1' || window.__florameGuidedTourDemoAutoStart === true;
  }

  function resolveLang() {
    try {
      var rootLang = String(document.documentElement.getAttribute('data-florame-lang') || document.documentElement.lang || '').toLowerCase();
      if (rootLang.indexOf('en') === 0) return 'en';
      var path = String(window.location.pathname || '').toLowerCase();
      if (path === '/en' || path.indexOf('/en/') === 0) return 'en';
      var stored = String(storageGet('florame_native_lang') || storageGet('bouquetLanguage') || '').toLowerCase();
      if (stored.indexOf('en') === 0) return 'en';
      var browser = String((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase();
      if (browser.indexOf('en') === 0) return 'en';
    } catch (_) {}
    return 'it';
  }

  function t(value) {
    if (!value || typeof value !== 'object') return String(value || '');
    return value[lang] || value.it || value.en || '';
  }

  var i18n = {
    it: {
      launcherTitle: 'Giro di Petali',
      launcherSub: 'Tour primo acquisto',
      close: 'Chiudi',
      skip: 'Salta',
      back: 'Indietro',
      next: 'Avanti',
      start: 'Inizia',
      finish: 'Apri creazione AI',
      action: 'Vai',
      mission: 'Missione lampo',
      mood: 'Scegli un mood',
      moodDone: 'Mood salvato',
      romantic: 'Romantico',
      bright: 'Colorato',
      elegant: 'Elegante'
    },
    en: {
      launcherTitle: 'Petal Tour',
      launcherSub: 'First order guide',
      close: 'Close',
      skip: 'Skip',
      back: 'Back',
      next: 'Next',
      start: 'Start',
      finish: 'Open AI creator',
      action: 'Go',
      mission: 'Quick mission',
      mood: 'Pick a mood',
      moodDone: 'Mood saved',
      romantic: 'Romantic',
      bright: 'Bright',
      elegant: 'Elegant'
    }
  };

  var steps = [
    {
      id: 'welcome',
      selector: 'body',
      scene: 'garden',
      placement: 'center',
      eyebrow: { it: 'Benvenuto nel giardino', en: 'Welcome to the garden' },
      title: { it: 'Ti accompagno al primo bouquet, senza perderti tra i petali.', en: 'Let’s get you to the first bouquet without getting lost in petals.' },
      body: {
        it: 'In pochi tocchi capisci come creare con AI, vedere bouquet già disponibili, scegliere un partner vicino e completare consegna o ritiro.',
        en: 'In a few taps you’ll learn AI creation, live available bouquets, nearby partners, and delivery or pickup.'
      },
      mission: 'mood'
    },
    {
      id: 'ai',
      selector: '.power-card.ai-card, a[href*="mode=funnel"], [data-tour-ai]',
      scene: 'wand',
      placement: 'right',
      eyebrow: { it: '1. Crea con AI', en: '1. Create with AI' },
      title: { it: 'Parti da un’idea, non da un catalogo infinito.', en: 'Start from an idea, not an endless catalog.' },
      body: {
        it: 'Racconti occasione, stile e budget. Florame traduce tutto in un bouquet acquistabile, poi ti fa rifinire colori e dettagli.',
        en: 'Tell Florame the occasion, style, and budget. It turns that into a buyable bouquet, then lets you refine colors and details.'
      },
      actionLabel: { it: 'Prova creazione', en: 'Try creation' },
      actionUrl: '/pages/florame-app?mode=funnel&tour=first-purchase'
    },
    {
      id: 'live',
      selector: '#availableCarouselSection, .available-live-section, [data-tour-live-stock]',
      scene: 'stock',
      placement: 'left',
      eyebrow: { it: '2. Disponibili subito', en: '2. Available now' },
      title: { it: 'Se hai fretta, guarda ciò che è davvero pronto.', en: 'If you’re in a hurry, see what is truly ready.' },
      body: {
        it: 'Il live stock mostra bouquet già compatibili con disponibilità reale. Meno attese, più certezza, soprattutto per regali last minute.',
        en: 'Live stock shows bouquets that match real availability. Less waiting, more confidence, especially for last-minute gifts.'
      },
      actionLabel: { it: 'Esplora live stock', en: 'Explore live stock' },
      actionUrl: '/pages/florame-app?mode=explore&f=available&sort=newest'
    },
    {
      id: 'partners',
      selector: '[data-florame-partner-directory-root], [data-tour-partners]',
      scene: 'map',
      placement: 'right',
      eyebrow: { it: '3. Fiorista giusto', en: '3. The right florist' },
      title: { it: 'Trovi partner per città, GPS o indirizzo di consegna.', en: 'Find partners by city, GPS, or delivery address.' },
      body: {
        it: 'La directory non è una vetrina statica: può dirti quali partner coprono davvero quell’indirizzo e portarti allo storefront corretto.',
        en: 'The directory is not static: it can show partners that actually cover that address and take you to the right storefront.'
      },
      actionLabel: { it: 'Cerca vicino a me', en: 'Search near me' },
      scrollOnly: true
    },
    {
      id: 'delivery',
      selector: '[data-home-focus-address], .delivery-scheduler, [data-tour-delivery]',
      scene: 'calendar',
      placement: 'left',
      eyebrow: { it: '4. Data, fascia, ritiro', en: '4. Date, slot, pickup' },
      title: { it: 'La parte noiosa diventa una scelta guidata.', en: 'The boring part becomes guided.' },
      body: {
        it: 'Inserisci indirizzo o scegli il ritiro quando disponibile. Il calendario evita fasce non valide e prepara anche notifiche e riprogrammazione.',
        en: 'Enter an address or choose pickup when available. The scheduler avoids invalid slots and supports notifications and rescheduling.'
      },
      actionLabel: { it: 'Vai all’indirizzo', en: 'Go to address' },
      scrollOnly: true
    },
    {
      id: 'checkout',
      selector: '.nav-item[data-id="cart"], a[href="/cart"], [data-tour-checkout]',
      scene: 'checkout',
      placement: 'center',
      eyebrow: { it: '5. Primo acquisto', en: '5. First order' },
      title: { it: 'Quando è tutto pronto, il carrello sa già cosa fare.', en: 'When everything is ready, the cart knows what to do.' },
      body: {
        it: 'Con partner, consegna, ritiro e disponibilità allineati, l’ultimo passo resta pulito: controlli il riepilogo e confermi.',
        en: 'With partner, delivery, pickup, and availability aligned, the final step stays clean: review and confirm.'
      },
      actionLabel: { it: 'Crea il primo bouquet', en: 'Create first bouquet' },
      actionUrl: '/pages/florame-app?mode=funnel&intent=first-bouquet'
    }
  ];

  function sceneSvg(scene) {
    var accent = selectedMood === 'elegant' ? '#20252b' : selectedMood === 'bright' ? '#00a99d' : '#ff4d75';
    var warm = selectedMood === 'bright' ? '#ffc766' : '#ff8d55';
    var soft = selectedMood === 'elegant' ? '#dfe7ec' : '#ffe5ec';
    var gradientId = 'ftSky' + (++svgSerial);
    var icon = '';

    if (scene === 'wand') {
      icon = '<g class="florame-tour-svg-float"><path d="M181 84l45-45 15 15-45 45z" fill="' + accent + '"/><path d="M223 43l15 15" stroke="#fff" stroke-width="5" stroke-linecap="round"/><circle cx="167" cy="107" r="18" fill="' + warm + '"/><path d="M154 107h26M167 94v26" stroke="#fff" stroke-width="5" stroke-linecap="round"/></g>';
    } else if (scene === 'stock') {
      icon = '<g class="florame-tour-svg-float"><rect x="152" y="48" width="92" height="74" rx="18" fill="#fff"/><path d="M172 100c15-31 34-31 51 0" fill="none" stroke="' + accent + '" stroke-width="8" stroke-linecap="round"/><circle cx="183" cy="79" r="10" fill="' + warm + '"/><circle cx="213" cy="79" r="10" fill="#65d6be"/><path d="M162 132h78" stroke="#24171c" stroke-opacity=".22" stroke-width="7" stroke-linecap="round"/></g>';
    } else if (scene === 'map') {
      icon = '<g class="florame-tour-svg-float"><path d="M196 42c-27 0-49 21-49 47 0 35 49 73 49 73s49-38 49-73c0-26-22-47-49-47z" fill="' + accent + '"/><circle cx="196" cy="89" r="19" fill="#fff"/><path d="M96 137c27-18 54-5 80 0s54 14 96-10" fill="none" stroke="#65d6be" stroke-width="10" stroke-linecap="round"/></g>';
    } else if (scene === 'calendar') {
      icon = '<g class="florame-tour-svg-float"><rect x="144" y="46" width="108" height="104" rx="20" fill="#fff"/><path d="M144 76h108" stroke="' + accent + '" stroke-width="10"/><path d="M171 42v21M225 42v21" stroke="#24171c" stroke-opacity=".45" stroke-width="8" stroke-linecap="round"/><circle cx="176" cy="106" r="10" fill="' + warm + '"/><circle cx="198" cy="106" r="10" fill="#65d6be"/><circle cx="220" cy="106" r="10" fill="' + accent + '"/><path d="M172 133h50" stroke="#24171c" stroke-opacity=".22" stroke-width="7" stroke-linecap="round"/></g>';
    } else if (scene === 'checkout') {
      icon = '<g class="florame-tour-svg-float"><path d="M142 65h20l14 75h66l14-52h-78" fill="none" stroke="' + accent + '" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><circle cx="187" cy="158" r="10" fill="#24171c"/><circle cx="229" cy="158" r="10" fill="#24171c"/><path d="M189 54c17 4 34 15 43 33" stroke="' + warm + '" stroke-width="8" stroke-linecap="round"/><path d="M205 45c-4 17-15 30-32 39" stroke="#65d6be" stroke-width="8" stroke-linecap="round"/></g>';
    } else {
      icon = '<g class="florame-tour-svg-float"><path d="M198 46c34 0 61 25 61 58 0 36-29 61-65 61-38 0-64-24-64-58 0-31 29-61 68-61z" fill="#fff"/><path d="M168 119c28-54 59-54 87 0" fill="none" stroke="' + accent + '" stroke-width="10" stroke-linecap="round"/><circle cx="182" cy="91" r="12" fill="' + warm + '"/><circle cx="222" cy="91" r="12" fill="#65d6be"/></g>';
    }

    return [
      '<svg viewBox="0 0 360 180" role="img" aria-hidden="true">',
      '<defs><linearGradient id="' + gradientId + '" x1="0" x2="1"><stop offset="0" stop-color="' + soft + '"/><stop offset="1" stop-color="#ecfff8"/></linearGradient></defs>',
      '<rect width="360" height="180" fill="url(#' + gradientId + ')"/>',
      '<path d="M20 136c45-20 82-20 132 0s97 20 188-8v52H20z" fill="#fff" opacity=".72"/>',
      '<ellipse cx="92" cy="138" rx="42" ry="9" fill="#24171c" opacity=".08"/>',
      '<g class="florame-tour-svg-drift"><path d="M74 68c18-15 31-8 27 11-19 3-31 0-27-11z" fill="' + accent + '" opacity=".72"/></g>',
      '<g class="florame-tour-svg-drift"><path d="M291 58c17-13 29-7 25 10-17 3-28 0-25-10z" fill="' + warm + '" opacity=".78"/></g>',
      '<g class="florame-tour-svg-drift"><path d="M54 119c14-11 25-6 21 8-14 3-23 0-21-8z" fill="#65d6be" opacity=".7"/></g>',
      icon,
      '<g class="florame-tour-svg-float" style="animation-delay:.35s"><circle cx="100" cy="78" r="24" fill="#fff"/><path d="M88 84c8 10 18 10 26 0" fill="none" stroke="#24171c" stroke-width="5" stroke-linecap="round"/><circle cx="91" cy="75" r="4" fill="#24171c"/><circle cx="110" cy="75" r="4" fill="#24171c"/><path d="M100 40c12 17 13 30 0 38-13-8-12-21 0-38z" fill="' + accent + '"/><path d="M74 61c20-2 31 4 31 18-15 7-26 1-31-18z" fill="' + warm + '"/><path d="M126 61c-20-2-31 4-31 18 15 7 26 1 31-18z" fill="#65d6be"/></g>',
      '</svg>'
    ].join('');
  }

  function createLauncher() {
    if (launcher || !isEnabled()) return;
    launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'florame-tour-launcher';
    launcher.setAttribute('aria-label', i18n[lang].launcherTitle);
    launcher.innerHTML = [
      '<span class="florame-tour-launcher-icon" aria-hidden="true">',
      sceneSvg('garden'),
      '</span>',
      '<span class="florame-tour-launcher-copy">',
      '<strong>' + i18n[lang].launcherTitle + '</strong>',
      '<span>' + i18n[lang].launcherSub + '</span>',
      '</span>'
    ].join('');
    launcher.addEventListener('click', function () { openTour(0); });
    document.body.appendChild(launcher);
  }

  function createShell() {
    if (shell) return shell;
    shell = document.createElement('div');
    shell.className = 'florame-tour-shell';
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-modal', 'true');
    shell.setAttribute('aria-label', 'Florame guided tour');
    shell.innerHTML = [
      '<div class="florame-tour-scrim" data-tour-close></div>',
      '<div class="florame-tour-spotlight" aria-hidden="true"></div>',
      '<article class="florame-tour-card">',
      '<div class="florame-tour-card-inner">',
      '<div class="florame-tour-top"><div class="florame-tour-visual"></div></div>',
      '<div class="florame-tour-body">',
      '<span class="florame-tour-eyebrow"></span>',
      '<h2 class="florame-tour-title"></h2>',
      '<p class="florame-tour-text"></p>',
      '<div class="florame-tour-mission" hidden></div>',
      '<div class="florame-tour-progress" aria-hidden="true"></div>',
      '</div>',
      '<footer class="florame-tour-footer">',
      '<button type="button" class="florame-tour-close" data-tour-close aria-label="' + i18n[lang].close + '"><svg viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>',
      '<div class="florame-tour-actions">',
      '<button type="button" class="florame-tour-btn florame-tour-btn--ghost" data-tour-skip>' + i18n[lang].skip + '</button>',
      '<button type="button" class="florame-tour-btn florame-tour-btn--soft" data-tour-back>' + i18n[lang].back + '</button>',
      '<button type="button" class="florame-tour-btn florame-tour-btn--primary" data-tour-next>' + i18n[lang].next + '</button>',
      '</div>',
      '</footer>',
      '</div>',
      '</article>',
      '<span class="florame-tour-live-region" aria-live="polite"></span>'
    ].join('');
    shell.addEventListener('click', onShellClick);
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(shell);
    liveRegion = qs('.florame-tour-live-region', shell);
    return shell;
  }

  function onShellClick(event) {
    if (event.target.closest('[data-tour-close]') || event.target.closest('[data-tour-skip]')) {
      closeTour();
      return;
    }
    if (event.target.closest('[data-tour-back]')) {
      goTo(currentIndex - 1);
      return;
    }
    if (event.target.closest('[data-tour-next]')) {
      onNext();
      return;
    }
    var pill = event.target.closest('[data-tour-mood]');
    if (pill) {
      selectedMood = pill.getAttribute('data-tour-mood') || '';
      storageSet(STORAGE_MOOD, selectedMood);
      renderStep();
    }
  }

  function onKeydown(event) {
    if (!shell || !shell.classList.contains('is-visible')) return;
    if (event.key === 'Escape') closeTour();
    if (event.key === 'ArrowRight') onNext();
    if (event.key === 'ArrowLeft') goTo(currentIndex - 1);
  }

  function targetForStep(step) {
    if (!step || !step.selector || step.selector === 'body') return null;
    var selectors = step.selector.split(',');
    for (var i = 0; i < selectors.length; i += 1) {
      var el = qs(selectors[i].trim());
      if (el) return el;
    }
    return null;
  }

  function updateSpotlight(target) {
    var spot = qs('.florame-tour-spotlight', shell);
    if (!spot) return;
    if (!target) {
      spot.classList.remove('is-on');
      return;
    }
    var rect = target.getBoundingClientRect();
    var pad = window.innerWidth < 720 ? 8 : 12;
    var left = clamp(rect.left - pad, 8, window.innerWidth - 16);
    var top = clamp(rect.top - pad, 8, window.innerHeight - 16);
    var width = clamp(rect.width + pad * 2, 60, window.innerWidth - 16);
    var height = clamp(rect.height + pad * 2, 44, window.innerHeight - 16);
    spot.style.left = (left + width / 2) + 'px';
    spot.style.top = (top + height / 2) + 'px';
    spot.style.width = width + 'px';
    spot.style.height = height + 'px';
    spot.classList.add('is-on');
  }

  function placeCard(target, step) {
    var card = qs('.florame-tour-card', shell);
    if (!card) return;
    if (window.innerWidth < 720) return;

    var cardW = Math.min(430, window.innerWidth - 28);
    var cardH = Math.min(470, window.innerHeight - 28);
    var left = window.innerWidth / 2;
    var top = window.innerHeight / 2;
    var placement = step.placement || 'center';

    if (target) {
      var rect = target.getBoundingClientRect();
      var gap = 28;
      if (placement === 'right') {
        left = rect.right + gap + cardW / 2;
        top = rect.top + rect.height / 2;
      } else if (placement === 'left') {
        left = rect.left - gap - cardW / 2;
        top = rect.top + rect.height / 2;
      } else if (placement === 'bottom') {
        left = rect.left + rect.width / 2;
        top = rect.bottom + gap + cardH / 2;
      } else if (placement === 'top') {
        left = rect.left + rect.width / 2;
        top = rect.top - gap - cardH / 2;
      }
    }

    left = clamp(left, cardW / 2 + 14, window.innerWidth - cardW / 2 - 14);
    top = clamp(top, cardH / 2 + 14, window.innerHeight - cardH / 2 - 14);
    card.style.left = left + 'px';
    card.style.top = top + 'px';
  }

  function renderMission(step) {
    var mission = qs('.florame-tour-mission', shell);
    if (!mission) return;
    if (step.mission !== 'mood') {
      mission.hidden = true;
      mission.innerHTML = '';
      return;
    }
    var labels = i18n[lang];
    mission.hidden = false;
    mission.innerHTML = [
      '<div class="florame-tour-mission-label"><span>' + labels.mission + '</span><span>' + (selectedMood ? labels.moodDone : labels.mood) + '</span></div>',
      '<div class="florame-tour-mission-pills">',
      moodButton('romantic', labels.romantic),
      moodButton('bright', labels.bright),
      moodButton('elegant', labels.elegant),
      '</div>'
    ].join('');
  }

  function moodButton(id, label) {
    return '<button type="button" class="florame-tour-pill' + (selectedMood === id ? ' is-selected' : '') + '" data-tour-mood="' + id + '">' + label + '</button>';
  }

  function renderProgress() {
    var progress = qs('.florame-tour-progress', shell);
    if (!progress) return;
    progress.innerHTML = steps.map(function (_, index) {
      return '<span class="florame-tour-petal' + (index <= currentIndex ? ' is-done' : '') + '"></span>';
    }).join('');
  }

  function renderStep() {
    if (!shell) return;
    var step = steps[currentIndex];
    var target = targetForStep(step);
    if (target && typeof target.scrollIntoView === 'function') {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); } catch (_) {}
    }

    qs('.florame-tour-visual', shell).innerHTML = sceneSvg(step.scene);
    qs('.florame-tour-eyebrow', shell).textContent = t(step.eyebrow);
    qs('.florame-tour-title', shell).textContent = t(step.title);
    qs('.florame-tour-text', shell).textContent = t(step.body);
    renderMission(step);
    renderProgress();

    var back = qs('[data-tour-back]', shell);
    var next = qs('[data-tour-next]', shell);
    back.disabled = currentIndex === 0;
    back.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
    next.textContent = currentIndex === 0
      ? i18n[lang].start
      : currentIndex === steps.length - 1
        ? (step.actionLabel ? t(step.actionLabel) : i18n[lang].finish)
        : i18n[lang].next;

    window.setTimeout(function () {
      updateSpotlight(target);
      placeCard(target, step);
    }, 90);

    if (liveRegion) liveRegion.textContent = t(step.eyebrow) + '. ' + t(step.title);
  }

  function onNext() {
    var step = steps[currentIndex];
    if (currentIndex === steps.length - 1) {
      runStepAction(step);
      closeTour();
      return;
    }
    if (step.actionUrl && currentIndex > 0 && getParams().get('florameTourAction') === '1') {
      runStepAction(step);
      return;
    }
    goTo(currentIndex + 1);
  }

  function runStepAction(step) {
    var target = targetForStep(step);
    if (step.scrollOnly && target) {
      try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      return;
    }
    if (step.actionUrl) {
      window.location.href = step.actionUrl;
    }
  }

  function goTo(index) {
    currentIndex = clamp(index, 0, steps.length - 1);
    renderStep();
  }

  function openTour(index) {
    if (!isEnabled()) storageSet(STORAGE_ENABLE, '1');
    selectedMood = storageGet(STORAGE_MOOD) || selectedMood || '';
    createShell();
    currentIndex = clamp(Number(index || 0) || 0, 0, steps.length - 1);
    document.documentElement.classList.add(ROOT_CLASS);
    shell.classList.add('is-visible');
    if (launcher) launcher.hidden = true;
    renderStep();
  }

  function closeTour() {
    if (!shell) return;
    document.documentElement.classList.remove(ROOT_CLASS);
    shell.classList.remove('is-visible');
    if (launcher) launcher.hidden = false;
    window.setTimeout(function () {
      if (shell && !shell.classList.contains('is-visible')) {
        document.removeEventListener('keydown', onKeydown);
        shell.remove();
        shell = null;
      }
    }, 220);
  }

  function init() {
    lang = resolveLang();
    selectedMood = storageGet(STORAGE_MOOD) || '';
    if (!isEnabled()) return;
    document.documentElement.setAttribute('data-florame-guided-tour-version', VERSION);
    createLauncher();
    if (shouldAutoStart()) {
      window.setTimeout(function () { openTour(0); }, 650);
    }
  }

  window.FlorameGuidedTour = {
    open: function (index) {
      storageSet(STORAGE_ENABLE, '1');
      openTour(index || 0);
    },
    close: closeTour,
    resetDemo: function () {
      storageRemove(STORAGE_ENABLE);
      storageRemove(STORAGE_MOOD);
      closeTour();
      if (launcher) {
        launcher.remove();
        launcher = null;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
